import type { FC, ReactNode } from 'react';

type CompactMobileHeaderProps = {
  businessName?: string | null;
  currentPageTitle?: string | null;
  leading?: ReactNode;
  logoUrl?: string | null;
  trailing?: ReactNode;
};

const CompactMobileHeader: FC<CompactMobileHeaderProps> = ({
  businessName,
  currentPageTitle,
  leading,
  logoUrl,
  trailing,
}) => {
  const mobileHeaderTitle = currentPageTitle ?? businessName ?? 'Panel';

  return (
    <div className="erp-layout-header__mobile-row">
      <div className="erp-layout-header__mobile-leading">
        {leading ? <div className="erp-layout-header__mobile-menu">{leading}</div> : null}
        {logoUrl ? (
          <img
            src={logoUrl}
            alt={businessName ?? 'Logo'}
            className="erp-layout-header__brand-logo"
          />
        ) : businessName ? (
          <span className="erp-layout-header__brand-fallback">{businessName}</span>
        ) : null}
      </div>

      <div className="erp-layout-header__mobile-title" title={mobileHeaderTitle}>
        {mobileHeaderTitle}
      </div>

      <div className="erp-layout-header__mobile-actions">{trailing}</div>
    </div>
  );
};

export default CompactMobileHeader;
